import { FormHelperText } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { FC } from "react";
import AuthCode from "react-auth-code-input";

interface ICodeInput {
  name: string;
}

const CodeInput: FC<ICodeInput> = ({ name }) => {
  const [field, meta] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const handleOnChange = (res: string) => {
    setFieldValue(field.name, res, false);
    if (res.length === 6) {
      setFieldTouched(field.name, false);
    } else {
      setFieldTouched(field.name, true);
    }
  };

  return (
    <div className="codeInput">
      <AuthCode onChange={handleOnChange} allowedCharacters="numeric" />
      <FormHelperText error={meta.touched && Boolean(meta.error)}>
        {meta.touched && meta.error}
      </FormHelperText>
    </div>
  );
};

export default CodeInput;
